import React          from 'react';
import { withRouter } from 'react-router';

class FourOFour extends React.Component {
  
  componentDidMount() {
    document.title = document.title.split("|")[0] + ' | 404';
  }

  render() {
    return (
      <div>
        Greetings from 404 world!
      </div>
    );
  }
}

export default withRouter(FourOFour);
